<div class="header-container">
  <div>
    <mat-form-field>
      <mat-label>Search for a formulary</mat-label>
      <input #nationalDrugFormularySearch matInput type="text" [formControl]="nationalDrugFormularyFormControl"
             data-qa="qa-input"
             (input)="onInputChangeFilterData('name')">
    </mat-form-field>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button [routerLink]="'/pharmacy-management/add-national-drug-formulary'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon>
      Add Formulary
    </button>
  </div>
</div>

<div *ngIf="!nationalDrugFormularyDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="nationalDrugFormularyDataSource" class="mat-elevation-z8 table-container">

  <table mat-table multiTemplateDataRows [dataSource]="nationalDrugFormularyDataSource"
         #nationalDrugFormularySort="matSort"
         matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editDrugFormularyTooltip="matTooltip"
                  matTooltip="EDIT National Drug Formulary"
                  [ngClass]="{'disabled': row.formularyClass?.value == 6}"
                  (click)="editEntry($event, row.nationalDrugFormularyId)">
          edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteDrugFormularyTooltip="matTooltip"
                  matTooltip="DELETE National Drug Formulary"
                  [ngClass]="{'disabled': !isAuthorisedToDelete}"
                  (click)="deleteEntry($event, row.nationalDrugFormularyId)">delete
        </mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="nationalDrugFormularyId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.nationalDrugFormularyId}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Name</th>
      <td *matCellDef="let row" mat-cell> {{row.name}}</td>
    </ng-container>

    <ng-container matColumnDef="formularyClass">
      <th *matHeaderCellDef mat-header-cell> Class</th>
      <td *matCellDef="let row" mat-cell> {{row.formularyClass.name}}</td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th *matHeaderCellDef mat-header-cell> Start Date</th>
      <td *matCellDef="let row" mat-cell> {{row.startDate | date: dateFormat}}</td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell> End Date</th>
      <td *matCellDef="let row" mat-cell> {{row.endDate | date: dateFormat}}</td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="nationalDrugFormularyDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == nationalDrugFormularyExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="nationalDrugFormularyDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: nationalDrugFormularyDisplayedColumns;" class="row"
        [class.expanded-row]="nationalDrugFormularyExpandedRow == row"
        (click)="nationalDrugFormularyExpandedRow = nationalDrugFormularyExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>

  </table>

  <mat-paginator #nationalDrugFormularyPaginator (page)="pageChanged($event)"
                 [length]="nationalDrugFormularyTableControl.length"
                 [pageSize]="nationalDrugFormularyTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="nationalDrugFormularyTableControl.pageSizeOptions">
  </mat-paginator>

</div>
